import {
  Modal,
  Button,
  Badge,
  Card,
  Group,
  Text,
  Image,
  Container,
  Grid,
  Stack,
  TextInput,
} from "@mantine/core";
import { GridPageType, ProductPlansData } from "../../../types/types";
import classes from "../GridItem/GridItem.module.css";
import { useState } from "react";
import planBg from "../../../assets/img/planBg.jpg";

interface ProductModalProps {
  opened: boolean;
  closed(): void;
  data: ProductPlansData[];
}

async function fetchCheckoutUrl(planCode: string, quantity: number): Promise<string> {
  const response = await fetch(`/server/client_service/checkout-link?planCode=${encodeURIComponent(planCode)}&quantity=${quantity}`);
  if (!response.ok) throw new Error("Failed to fetch checkout link");
  const data = await response.json();
  // Expecting { url: "..." }
  return data.url;
}

export function ProductModal(props: ProductModalProps) {
  console.log("Prop data is ", props.data);
  const [embedUrl, setEmbedUrl] = useState("");
  const [quantity, setQuantity] = useState<{ [key: string]: string }>({});

  async function handlePurchase(plan: ProductPlansData) {
    const qty = quantity[plan.Plan_Code];
    if (!qty || isNaN(Number(qty)) || Number(qty) < 1) {
      alert("Please enter a valid quantity for this plan.");
      return;
    }
    const url = await fetchCheckoutUrl(plan.Plan_Code, Number(qty));
    setEmbedUrl(url);
  }

  function handleClose() {
    setEmbedUrl("");
  }

  return (
    <>
      <Container my="md">
        <Modal
          opened={props.opened}
          onClose={props.closed}
          size="xl"
          title="Available plans"
          centered
          overlayProps={{
            backgroundOpacity: 0.55,
            blur: 3,
          }}
        >
          {embedUrl.length > 0 ? (
            <Stack
              h="60vh"
              bg="var(--mantine-color-body)"
              align="center"
              justify="center"
              gap="md"
            >
              <Button onClick={handleClose} style={{ backgroundColor: "#00ddb3", color: "white" }}>Cancel</Button>
              <iframe height="100%" src={embedUrl}></iframe>
              
            </Stack>
          ) : (
            <Grid>
              {props.data.map((plan, i) => (
                <Grid.Col key={plan.Plan_Code} span={{ base: 12, xs: 6 }}>
                  <Card withBorder radius="md" p="md" className={classes.card}>
                    <Card.Section>
                      <Image
                        src={plan.ImageURL}
                        alt={"Placeholder image"}
                        height={180}
                        fallbackSrc={planBg}
                      />
                    </Card.Section>

                    <Card.Section className={classes.section} mt="md">
                      <Group justify="apart">
                        <Text fz="lg" fw={500}>
                          {plan.Name}
                        </Text>
                        <Badge size="sm" variant="light">
                          {plan.Status}
                        </Badge>
                      </Group>
                      <Text fz="sm" mt="xs">
                        <strong>Plan Code:</strong> {plan.Plan_Code} 
                        <br />
                        <strong>Billing Period:</strong> {plan.Interval_Unit}
                        <br />
                        <strong>Billing Cycles:</strong> {plan.Billing_Cycles == "-1" ? "indefinite" : plan.Billing_Cycles}
                        <br />
                        <strong>Price:</strong> R{plan.Recurring_Price}
                      </Text>
                      <TextInput
                        type="number"
                        label="Quantity"
                        placeholder="Enter quantity"
                        required
                        min={1}
                        value={quantity[plan.Plan_Code] || ""}
                        onChange={e =>
                          setQuantity({
                            ...quantity,
                            [plan.Plan_Code]: e.currentTarget.value,
                          })
                        }
                      />
                    </Card.Section>
                    <Group mt="xs">
                      <Button
                        variant="gradient"
                        gradient={{ from: "#00ddb3", to: "#00ddb3", deg: 125 }}
                        radius="md"
                        style={{ flex: 1 }}
                        onClick={() => handlePurchase(plan)}
                      >
                        Subscribe
                      </Button>
                    </Group>
                  </Card>
                </Grid.Col>
              ))}
            </Grid>
          )}
        </Modal>
      </Container>
    </>
  );
}
